import { useState } from 'react';
import * as C from './styles.js';
import bcrypt from 'bcryptjs';
import { deleteDoc, doc, getFirestore } from 'firebase/firestore';
import { AppFirebase } from '../../../../config/firebase.js';

export default function DeleteProfile({ user, profile, setUser, getProfiles, userUid, setManageProfiles }) {

    const [ msgErro, setMsgErro ] = useState();
    const [ loadingDeleteProfile, setLoadingDeleteProfile ] = useState();

    const database = getFirestore(AppFirebase);

    const deleteProfile = async (e) => {
        e.preventDefault();
    
        try {
            setLoadingDeleteProfile(true);
            await deleteDoc(doc(database, `/profiles/${profile.profile_uid}`)).then(()=> {
                getProfiles(user.uid);
                setTimeout(() => {
                    setUser({});
                    setManageProfiles(false);
                }, 1000);
            });
        } catch (error) {
            setMsgErro('Ocorreu um erro, tente novamente');
        }
    }    

    return(
        <C.Container>
            <header>
                <h2 className='title-welcome'>Excluir perfil</h2>
            </header>
            <form method='' action='' onSubmit={deleteProfile} className='form-login-cadastrar'>
                <div>
                    <section className='section-profile-delete'>
                        <img src={profile.profile_photo_url} alt='avatar' />
                        <div className='div-input-delete-profile'>
                            <span className='profile_name'>{profile.profile_name}</span>
                            <span className='profile_email'>{profile.account_email}</span>
                        </div>
                    </section>
                </div>
                <div className='div-message-erro'>
                    <p className='descricao-erro'>{msgErro}</p>
                </div>
                <section className='section-bts-delete-profile'>
                    <button type='submit'>{loadingDeleteProfile ? <div className="spinner-user-login is-animating"></div> : 'Excluir'}</button>
                    <button type='button' onClick={()=>setUser({})}>Cancelar</button>
                </section>
            </form>
        </C.Container>
    )
}